const config = {
    build_number: '616459',
    build_timestamp: '2026-09-30T16:28:50.214Z',
    build_commit: 'a13ade62826ec1ec2e15d7f3b765dba1791bd8e4',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
